import * as Yup from 'yup';

import { TOOL_STATUS, TOOL_TYPE, type ToolStatus, type ToolType } from '@/types/tool.type';

const headerParamSchema = Yup.object().shape({
  uid: Yup.string().optional(),
  key: Yup.string().required('Key is required'),
  value: Yup.string().required('Value is required'),
});

export const createToolSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .min(3, 'Name must be at least 3 characters')
    .max(100, 'Name must not exceed 100 characters')
    .required('Tool name is required'),
  description: Yup.string()
    .trim()
    .max(500, 'Description must not exceed 500 characters')
    .required('Description is required'),
  type: Yup.string().oneOf(Object.values(TOOL_TYPE)).required('Type is required'),
  status: Yup.string().oneOf(Object.values(TOOL_STATUS)).required('Status is required'),
  enabled: Yup.boolean().required(),
  url: Yup.string()
    .url('Must be a valid URL')
    .when('type', {
      is: 'MCP',
      then: schema => schema.required('URL is required for MCP tools'),
      otherwise: schema => schema.optional(),
    }),
  timeout: Yup.number().required('Timeout is required').min(1, 'Timeout must be greater than 0'),
  client_session_timeout_seconds: Yup.number()
    .required('Client session timeout is required')
    .min(1, 'Client session timeout must be greater than 0'),
  headers: Yup.array().of(headerParamSchema).optional(),
  query_params: Yup.array().of(headerParamSchema).optional(),
});

export const updateToolSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .min(3, 'Name must be at least 3 characters')
    .max(100, 'Name must not exceed 100 characters')
    .required('Tool name is required'),
  description: Yup.string()
    .trim()
    .max(500, 'Description must not exceed 500 characters')
    .required('Description is required'),
  status: Yup.string().oneOf(Object.values(TOOL_STATUS)).required('Status is required'),
  enabled: Yup.boolean().required(),
  url: Yup.string().url('Must be a valid URL').optional(),
  timeout: Yup.number().required('Timeout is required').min(1, 'Timeout must be greater than 0'),
  client_session_timeout_seconds: Yup.number()
    .required('Client session timeout is required')
    .min(1, 'Client session timeout must be greater than 0'),
  headers: Yup.array().of(headerParamSchema).optional(),
  query_params: Yup.array().of(headerParamSchema).optional(),
});

export type CreateToolFormValues = Omit<
  Yup.InferType<typeof createToolSchema>,
  'status' | 'type'
> & {
  status: ToolStatus;
  type: ToolType;
};
export type UpdateToolFormValues = Omit<Yup.InferType<typeof updateToolSchema>, 'status'> & {
  status: ToolStatus;
};
